import HeroSection from "./sections/hero";
import About from "./sections/about";
import Skills from "./sections/skills";
import WorkFields from "./sections/workFields";
import Logos from "./sections/logos";
import Vectors from "./sections/vectors";
import Raster from "./sections/raster";
import Web from "./sections/web";
import Animation from "./sections/animation";
import Design from "./sections/design";
import Contacts from "./sections/contacts";

import styles from "./styles.module.scss";

function App() {
  return (
    <div>
      <HeroSection />
      <About />
      <div className={styles.container}>
        <Skills />
        <WorkFields />
      </div>
      <Logos />
      <Vectors />
      <div className={styles.container}>
        <Raster />
        <Web />
      </div>
      <Animation />
      <Design />
      <Contacts />
    </div>
  );
}

export default App;
